import { useDecision } from '@optimizely/react-sdk'
import { useSelector } from 'react-redux'

import { useGoustoAnytimeMenuVariant } from 'routes/Menu/experiments/GoustoAnytime/useGoustoAnytimeMenuVariant'
import { getBasketOrderDetails } from 'selectors/basket'
import { getIsFromEmptyStateDashboard } from 'selectors/oneOffOrderOrigin'
import { getUserSubscriptionState } from 'selectors/user'

const GOUSTO_ANYTIME_FLAG = 'tomatoes_ofx_webclient_gousto_anytime'

type OrderDetailsImmutable = { get: (key: 'orderType') => string | undefined }

// Mirrors `useShowGoustoAnytimeOrderConfirmationBanner` (experiment enabled + menu-experience
// variant + non-subscriber + transactional order) and adds the web-only empty-state-dashboard
// origin gate. Placement inside the header-only Section 1 already handles the `showHeader` case.
export const useShowResubscriptionPrompt = (): boolean => {
  const [decision] = useDecision(GOUSTO_ANYTIME_FLAG)
  // Read the order type off the order loaded on the confirmation page (fetched by id from the
  // URL), not user.orders: the just-created order isn't in user.orders until a reload.
  const orderDetails = useSelector(getBasketOrderDetails) as
    | OrderDetailsImmutable
    | false
    | undefined
  const subscriptionState = useSelector(getUserSubscriptionState) as string | undefined
  const isInMenuExperienceVariant = useGoustoAnytimeMenuVariant()
  const isFromEmptyStateDashboard = useSelector(getIsFromEmptyStateDashboard)

  const isTransactional = !!orderDetails && orderDetails.get('orderType') === 'transactional'
  const hasActiveSubscription = subscriptionState === 'active'

  return (
    decision.enabled &&
    isInMenuExperienceVariant &&
    isTransactional &&
    !hasActiveSubscription &&
    isFromEmptyStateDashboard
  )
}
